import { DEFAULT_ARTICLE_NUMBER, DEFAULT_RECIPE_NUMBER } from "@/utils/constant";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PagecountState {
  pagecount: number;
  recipePagecount: number;
  articlePagecount:number;
}

const initialPagecountState: PagecountState = {
  pagecount: 20,
  recipePagecount: DEFAULT_RECIPE_NUMBER,
  articlePagecount:DEFAULT_ARTICLE_NUMBER
};

const pagecountSlice = createSlice({
  name: "paginationSlice",
  initialState: initialPagecountState,
  reducers: {
    setPagecount(state, action: PayloadAction<number>) {
      state.pagecount = action.payload;
    },
  },
});

export const { setPagecount } = pagecountSlice.actions;

export const paginationSlice = pagecountSlice.reducer;
